export const ENTITY_BADGE_VARIANTS = {
  individual: 'bg-info-subtle text-info-emphasis',
  organization: 'bg-primary-subtle text-primary-emphasis',
  club: 'bg-success-subtle text-success-emphasis',
  community: 'bg-warning-subtle text-warning-emphasis',
};

export const ENTITY_BADGE_LABELS = {
  individual: 'IND',
  organization: 'ORG',
  club: 'CLUB',
  community: 'COM',
};

export const getEntityType = (value = '') => String(value || 'individual').toLowerCase();

export const getEntityBadgeClasses = (entityType) =>
  ENTITY_BADGE_VARIANTS[getEntityType(entityType)] || 'bg-secondary-subtle text-secondary-emphasis';

export const getEntityBadgeLabel = (entityType) =>
  ENTITY_BADGE_LABELS[getEntityType(entityType)] || String(entityType || 'IND').toUpperCase();

export const getStatusBadge = (status, isLive = false) => {
  if (isLive) return { label: 'LIVE', className: 'text-bg-danger' };

  const normalized = String(status || '').toLowerCase();
  if (['completed', 'finished'].includes(normalized)) {
    return { label: 'COMPLETED', className: 'bg-secondary-subtle text-secondary-emphasis' };
  }
  if (['upcoming', 'scheduled', 'not_started'].includes(normalized)) {
    return { label: 'UPCOMING', className: 'bg-warning-subtle text-warning-emphasis' };
  }
  if (['in_progress', 'ongoing', 'live'].includes(normalized)) {
    return { label: 'LIVE', className: 'text-bg-danger' };
  }
  return { label: 'ACTIVE', className: 'bg-success-subtle text-success-emphasis' };
};

export const handleInteractiveKeyDown = (event, onClick) => {
  if ((event.key === 'Enter' || event.key === ' ') && onClick) {
    event.preventDefault();
    onClick();
  }
};
